module.exports = __webpack_public_path__ + "img/8.38181999.png";